import CodeEditorArea, { CodeEditorAreaProps } from './CodeEditorArea';

export type { CodeEditorAreaProps };
export default CodeEditorArea;
